// colors.js

export const APP_BACKGROUND_COLOR = "#A5B4FC";
export const START_NEXT_TRY_AGAIN_BUTTONS_COLOR = "#6ED5B7";
export const PREVIOUS_BUTTON_COLOR = "#6B7280";
export const SUBMIT_RESTART_BUTTONS_COLOR = "#F59E0B";
export const ANSWERS_HOVER_BACKGROUND_COLOR = "#312E81";
export const TIMER_COLOR = "#312E81";
export const CURRENT_QUESTIONS_COLOR = "#312E81";
export const INCORRECT_ANSWER_COLOR = "#EF4444";
export const CORRECT_ANSWER_COLOR = "#10B981";

// Export all as a grouped object (optional, if needed)
export const COLORS = {
  APP_BACKGROUND_COLOR,
  START_NEXT_TRY_AGAIN_BUTTONS_COLOR,
  PREVIOUS_BUTTON_COLOR,
  SUBMIT_RESTART_BUTTONS_COLOR,
  ANSWERS_HOVER_BACKGROUND_COLOR,
  TIMER_COLOR,
  CURRENT_QUESTIONS_COLOR,
  INCORRECT_ANSWER_COLOR,
  CORRECT_ANSWER_COLOR
};
